import { render, staticRenderFns } from "./ReportLayout.vue?vue&type=template&id=2ba6ed77"
import script from "./ReportLayout.vue?vue&type=script&lang=js"
export * from "./ReportLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports